import React from "react";
import PropTypes from "prop-types";

const DownloadCheckbox = ({ type, input, text, meta }) => {
    const classes = meta.submitFailed && meta.error ? "is-error" : "";

    return (
        <React.Fragment>
            <input
                className={classes}
                id={input.name}
                type="checkbox"
                {...input}
            />
            <span dangerouslySetInnerHTML={{ __html: text }} />
            {meta.submitFailed && meta.error && (
                <div className="optin__error">{meta.error[0]}</div>
            )}
        </React.Fragment>
    );
};

DownloadCheckbox.propTypes = {
    type: PropTypes.string.isRequired,
    input: PropTypes.shape({
        name: PropTypes.string.isRequired
    }).isRequired,
    text: PropTypes.string.isRequired,
    meta: PropTypes.shape({
        touched: PropTypes.bool.isRequired,
        error: PropTypes.arrayOf(PropTypes.string)
    }).isRequired
};

export default DownloadCheckbox;
